module.exports = {"id":"232862","name":"Shoya Nakajima","rating":"75","photo":"./data/images/photos/4/232862.png","club":{"name":"Portimão","logo":"./data/images/clubs/Portimao.png"},"positions":["AG","BU"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/ShoyaNakajima0.json
// module id = 3943
// module chunks = 0